import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from "./PageContext";
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';
// import OrderedDataTable from './OrderedDataTableCopy.jsx';
// import StandardRowFormatted from './StandardRowFormatted'; 
import standardFilter from '../functions/standardFilter.js';
import applyFilters from '../functions/applyFilters.js';
import isNullOrUndefined from '../functions/isNullOrUndefined.js'; 
import MergedDataTable from './MergedDataTable.jsx'; 
import MergedRow from './MergedRow.jsx'; 

const InfoModal = ({title, ovrDefault = true}) => {
    // get context from parent
    const { 
        showInfoModal, 
        setShowInfoModal, 
        infoModalLabel, 
        infoModalData, 
        infoModalTableHeader, 
        infoModalId,
        setInfoModalId, 
        showSpinner
    } = useContext(PageContext);
    // initialize state
    const [data, setData] = useState([]); 
    const [tableHeader, setTableHeader] = useState([]); 
    // initailize ref for useEffect
    const initialRender = useRef(true); 
    // wrap row function in to pass to table for OrderedDataTable
    // const RowComponent = ( row, count, tableHeader) => {
    //     return <StandardRowFormatted row={row} count={count} tableHeader={tableHeader} enableEdit={false} /> // no edit
    // } 
    const MergedRowComponent = (row, count, tableHeader1, stickyFirstColumnEnabled, index, selectableRows, rowSpanMeta) => {
        return <MergedRow 
            row={row} 
            count={count} 
            tableHeader={tableHeader} 
            stickyFirstColumnEnabled={stickyFirstColumnEnabled} 
            index={index} 
            selectableRows={selectableRows} 
            firstColMeta={rowSpanMeta}
        />
    }
    // useEffect to filter infoModalData based on selected infoModalLabel
    useEffect(() => {
        // do not run on initial render
        if (!initialRender.current){
            if (!isNullOrUndefined(infoModalLabel) && !isNullOrUndefined(infoModalData)) {
                // declare list of functions with parameters to filter/search list
                const functionList = [
                    {function: standardFilter, value: infoModalLabel, flag: 1, cols: ['label']}, 
                    {function: standardFilter, value: infoModalId, flag: 1, cols: ['id']}
                ];
                // use applyFilters function to search by running all functions declared above
                let filteredList = applyFilters(infoModalData, functionList);
                // update data
                setData(filteredList);
            }
        }
        else{
            initialRender.current = false;
        }
    }, [infoModalLabel, infoModalData, infoModalId]);
    
    // useEffect to filter table header determined by infoModalId
    useEffect(() => {
        if (!isNullOrUndefined(infoModalId) && !isNullOrUndefined(infoModalTableHeader)) {
            setTableHeader(infoModalTableHeader[infoModalId]); 
        }
        // if just table header default to first key in headers obj
        else if (!ovrDefault && !isNullOrUndefined(infoModalTableHeader)) {
            let temp = Object.keys(infoModalTableHeader)[0]; 
            if (!isNullOrUndefined(temp)){
                setInfoModalId(temp); 
            }
        }
    }, [infoModalId, infoModalTableHeader]); 

    return(
        <> 
            <CCOffcanvas
                title={title + ': ' + infoModalLabel}
                show={showInfoModal}
                onCanvasClose={()=>setShowInfoModal(false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card"
                >
                    <div className="d-flex flex-column h-100">
                        <div className="p-3 trail-section flex-grow-1 overflow-scroll">
                            <div className="bg-white trail-card">
                                {/* <OrderedDataTable sortingEnabled={true} varHeight='210px' RowComponent={RowComponent} tableHeader={tableHeader} dataList={data} showSpinner={showSpinner} numToPage={25} skeletonHeight='14vh' /> */}
                                <MergedDataTable stickyFirstColumnEnabled={true} sortingEnabled={true} varHeight='210px' RowComponent={MergedRowComponent} tableHeader={tableHeader} dataList={data} showSpinner={showSpinner} numToPage={25} skeletonHeight='14vh' />
                            </div>
                        </div>
                        <div
                            className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setShowInfoModal(false)}
                            />   
                        </div>
                    </div>
            </CCOffcanvas>
        </>
    );
}

export default InfoModal; 